import { AppManager, AppRegistry } from 'core/index';
import { observable, computed, action } from 'mobx';

import { onInit } from 'core/config';

import { clientStore } from 'apps/client/app';
import { SignInAppManager } from 'apps/signIn/main/appManager';

import { conf } from 'apps/components/header/config.yaml';

import i18next from 'i18next';

class HeaderStore extends AppManager {
  init = () => {
    clientStore.context.set('signInAppManager', new SignInAppManager());
    this.AppRef('profile', AppRegistry.get('ProfileApp'));
    this.AppRef('initiative', AppRegistry.get('InitiativeApp'));
    this.AppRef('project', AppRegistry.get('ProjectApp'));
  };

  @computed get route() {
    return clientStore.spaceRoute.route;
  }

  get nav() {
    /* unused? */
    if (
      (this.route === 'home' && clientStore.routeSegments.length > 1) ||
      clientStore.routeSegments.includes('home') ||
      clientStore.routeSegments.includes('collection') ||
      clientStore.routeSegments.includes('story') ||
      clientStore.routeSegments.includes('issue') ||
      clientStore.routeSegments.includes('settings') ||
      clientStore.routeSegments.includes('repoDirectory') ||
      clientStore.routeSegments.includes('contribution') ||
      clientStore.routeSegments.includes('invitations')
    ) {
      return [];
    }
    let navItems = Object.create(conf.navs[this.route]);
    navItems = navItems.map(item => ({ name: i18next.t(item), link: item }));
    if (this.route === 'profile') {
      if (this.profile === null || this.profile === undefined) {
        return [];
      }
      if (this.profile) {
        /*
         * Why for some users this.profile.username is empty,
         * having to resort to this.profile.user.username?
         */
        // FIXME
        if (clientStore.spaceParams.profile !== this.profile.user.username) {
          return [];
        }
        navItems = navItems.map(item => ({
          name: this.profile.canUpdate
            ? i18next.t('My {{item}}', { item: item.name })
            : item.name,
          link: item.link,
        }));
        if (this.profile.canUpdate) {
          navItems.splice(0, 0, { name: i18next.t('Me') });
        } else {
          const displayName = this.profile.fullName.split(' ')[0];
          navItems.splice(0, 0, { name: displayName });
        }
      }
    }
    if (this.route === 'initiative') {
      if (this.initiative === null || this.initiative === undefined) {
        return [];
      }
      if (this.initiative) {
        if (clientStore.spaceParams.initiative !== this.initiative.slug) {
          return [];
        }
        navItems = navItems.map(item => ({
          name: this.initiative.canUpdate
            ? i18next.t('Our {{item}}', { item: item.name })
            : item.name,
          link: item.link,
        }));
        navItems.splice(0, 0, { name: this.initiative.title, link: '' });
      }
    }
    if (
      clientStore.routerStore.route.name === 'profile.project.repoDirectory' ||
      clientStore.routerStore.route.name === 'initiative.project.repoDirectory'
    ) {
      return [
        { name: 'Folder', link: 'Folder' },
        { name: 'Readme', link: 'Readme' },
      ];
    }
    if (
      clientStore.routerStore.route.name === 'profile.project.repoFile' ||
      clientStore.routerStore.route.name === 'initiative.project.repoFile'
    ) {
      return [
        { name: 'File', link: 'File' },
        { name: 'Comments', link: 'Comments' },
      ];
    }
    return navItems;
  }

  @computed get isPrivateProject() {
    return this.project && this.project.private;
  }

  @action SetPage = pageModel => {
    if (this.pageType) {
      this[this.pageType] = null;
    }
    this.pageType = pageModel.constructor.registryName
      .replace('Model', '')
      .toLowerCase();
    this[this.pageType] = pageModel;
  };

  @observable userDropdownVisible = false;
  @action ShowUserDropdown = () => {
    this.CloseAllMenus();
    this.userDropdownVisible = true;
  };

  @action HideUserDropdown = () => {
    this.userDropdownVisible = false;
  };

  @action ToggleUserDropdown = () => {
    if (!this.userDropdownVisible) this.CloseAllMenus();
    this.userDropdownVisible = !this.userDropdownVisible;
  };

  @observable notifCenterVisible = false;
  @action ShowNotifDropdown = () => {
    this.CloseAllMenus();
    this.notifCenterVisible = true;
  };

  @action HideNotifDropdown = () => {
    this.notifCenterVisible = false;
  };

  @action ToggleNotifCenter = () => {
    if (!this.notifCenterVisible) this.CloseAllMenus();
    this.notifCenterVisible = !this.notifCenterVisible;
  };

  @observable hamburgerActive = false;
  @action ToggleHamburger = () => {
    if (!this.hamburgerActive) this.CloseAllMenus();
    this.hamburgerActive = !this.hamburgerActive;
  };

  @observable searchIsVisible = false;
  @observable searchTerm = '';
  @observable lastSearchTerm = '';

  @computed get searchedTerm() {
    const searchQuery = clientStore.routerStore.params.get('q');
    const decodedQuery = searchQuery ? decodeURIComponent(searchQuery) : '';
    return this.lastSearchTerm || decodedQuery || '';
  }

  @action ShowSearch = () => {
    this.searchIsVisible = true;
  };

  @action HideSearch = () => {
    this.searchIsVisible = false;
    this.searchTerm = '';
  };

  @action UpdateSearchTerm = term => {
    this.searchTerm = term;
  };

  @action ResetSearchTerm = () => {
    this.searchTerm = '';
  };

  @action NavigateToSearchPage = () => {
    this.lastSearchTerm = this.searchTerm;
    const q = encodeURIComponent(this.searchTerm);
    clientStore.routerStore.navigate('home.search', { q });
    this.searchTerm = '';
  };

  @observable langDropdownVisible = false;
  @action SetLangDropdownVisibility = () => {
    this.langDropdownVisible = !this.langDropdownVisible;
  };

  @action CloseAllMenus = () => {
    if (this.notifCenterVisible) this.notifCenterVisible = false;
    if (this.userDropdownVisible) this.userDropdownVisible = false;
    if (this.hamburgerActive) this.hamburgerActive = false;
    if (this.searchIsVisible) this.searchIsVisible = false;
  };
}

export const headerStore = new HeaderStore();
onInit(headerStore.init);
